import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      formConfig: _ctx.formConfig,
      onResetBtnClick: _ctx.resetBtnClick,
      onQueryBtnClick: _ctx.queryBtnClick
    }, null, 8, ["formConfig", "onResetBtnClick", "onQueryBtnClick"]),
    _createVNode(_component_PageContent, {
      ref: "pageContentRef",
      pageName: "users",
      contentConfig: _ctx.contentConfig,
      onEditBtnClick: _ctx.editBtnClick,
      onNewBtnClick: _ctx.newBtnClick
    }, null, 8, ["contentConfig", "onEditBtnClick", "onNewBtnClick"]),
    _createVNode(_component_PageModal, {
      ref: "pageModalRef",
      pageName: "users",
      modalConfig: _ctx.userModalConfig
    }, null, 8, ["modalConfig"])
  ]))
}